// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".follower-send-message-history-table-component .overflow-hidden[data-v-ceae8eac]{overflow:hidden!important;text-overflow:ellipsis;white-space:nowrap}.follower-send-message-history-table-component .detail-btn[data-v-ceae8eac]{width:64px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
